module.exports = {"pagination":{"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/marketplace-catalog-2018-09-17.paginators.json
// module id = 259
// module chunks = 1